'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* istanbul ignore file */


/**
 * Exposed Pagination Props will be passed into wrappedcomponent
 */
var defaultPageSizeOptions = [5, 10, 15, 20];

function withPaginator(WrappedComponent) {
  var _class, _temp, _initialiseProps;

  return _temp = _class = function (_Component) {
    _inherits(PrivatePaginator, _Component);

    function PrivatePaginator(props) {
      _classCallCheck(this, PrivatePaginator);

      var _this = _possibleConstructorReturn(this, (PrivatePaginator.__proto__ || Object.getPrototypeOf(PrivatePaginator)).call(this, props));

      _initialiseProps.call(_this);

      var _props$defaultCurrent = props.defaultCurrent,
          defaultCurrent = _props$defaultCurrent === undefined ? 1 : _props$defaultCurrent,
          current = props.current,
          pageSize = props.pageSize,
          defaultPageSize = props.defaultPageSize,
          _props$pageSizeOption = props.pageSizeOptions,
          pageSizeOptions = _props$pageSizeOption === undefined ? defaultPageSizeOptions : _props$pageSizeOption;

      if (!pageSize) {
        pageSize = defaultPageSize ? defaultPageSize : Number(pageSizeOptions[0]);
      }
      _this.state = {
        current: current ? current : defaultCurrent,
        pageSize: pageSize
      };
      return _this;
    }

    _createClass(PrivatePaginator, [{
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var current = nextProps.current,
            pageSize = nextProps.pageSize;

        var state = void 0;
        if (current && current !== this.state.current) {
          state = { current: current };
        }

        if (pageSize && pageSize !== this.state.pageSize) {
          if (state) {
            state = _extends({}, state, { pageSize: pageSize });
          } else {
            state = { pageSize: pageSize };
          }
        }
        if (state) {
          this.setState(state);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var next = this.next,
            prev = this.prev,
            hasNext = this.hasNext,
            hasPrev = this.hasPrev,
            calculatePages = this.calculatePages,
            setCurrentPage = this.setCurrentPage,
            changePageSize = this.changePageSize;
        var _state = this.state,
            current = _state.current,
            pageSize = _state.pageSize;

        var otherProps = _objectWithoutProperties(this.props, []);

        var passedProps = _extends({}, otherProps, {
          next: next,
          prev: prev,
          calculatePages: calculatePages,
          hasNext: hasNext,
          hasPrev: hasPrev,
          value: current,
          setCurrentPage: setCurrentPage,
          changePageSize: changePageSize,
          pageSize: pageSize
        });

        return _react2.default.createElement(WrappedComponent, passedProps);
      }
    }]);

    return PrivatePaginator;
  }(_react.Component), _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.hasPrev = function () {
      return _this2.state.current > 1;
    };

    this.hasNext = function () {
      var pageNums = _this2.calculatePages();
      return _this2.state.current < Number(pageNums);
    };

    this.prev = function () {
      if (_this2.state.current <= 1) {
        return;
      }
      var current = _this2.state.current - 1;
      _this2.setCurrentPage(current);
    };

    this.next = function () {
      var pageNums = _this2.calculatePages();
      if (_this2.state.current >= Number(pageNums)) {
        return;
      }
      var current = _this2.state.current + 1;
      _this2.setCurrentPage(current);
    };

    this.setCurrentPage = function (page) {
      var onChange = _this2.props.onChange;

      var pageNums = _this2.calculatePages();
      if (page < 1 || page > pageNums) {
        return;
      }
      var previousPage = _this2.state.current;

      if (previousPage !== page) {
        _this2.setState({
          current: page
        });
        var eventType = 'jump';
        if (page - previousPage === 1) {
          eventType = 'next';
        } else if (page - previousPage === -1) {
          eventType = 'prev';
        }
        onChange && onChange(eventType, page);
      }
    };

    this.calculatePages = function () {
      var total = _this2.props.total;
      var pageSize = _this2.state.pageSize;

      var pageNums = Math.floor((Number(total) - 1) / pageSize) + 1;
      return pageNums === 0 ? 1 : pageNums;
    };

    this.changePageSize = function (pageSize) {
      var onPageSizeChange = _this2.props.onPageSizeChange;

      if (pageSize < 1) {
        return;
      }
      if (pageSize !== _this2.state.pageSize) {
        _this2.setState({
          current: 1,
          pageSize: pageSize
        });
        onPageSizeChange && onPageSizeChange(pageSize);
      }
    };
  }, _temp;
}

exports.default = withPaginator;